import React from "react";
import { useTheme } from "@mui/material/styles";

const ChangeTemplateIcon = ({ color }) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.dark;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.465"
      height="37.512"
      viewBox="0 0 29.465 37.512"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_6627"
            data-name="Rectangle 6627"
            width="29.465"
            height="37.512"
            transform="translate(0 0)"
            fill={color}
          />
        </clipPath>
      </defs>
      <g id="Group_7171" data-name="Group 7171" transform="translate(0 0)">
        <g id="Group_7170" data-name="Group 7170" clipPath="url(#clip-path)">
          <path
            id="Path_8206"
            data-name="Path 8206"
            d="M21,29H3V3H21ZM22,0H2A2,2,0,0,0,0,2V30a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2"
            fill={color}
          />
          <path
            id="Path_8207"
            data-name="Path 8207"
            d="M25.965,37.512h-20v-3h20a.5.5,0,0,0,.5-.5v-28h3v28a3.5,3.5,0,0,1-3.5,3.5"
            fill={color}
          />
          <rect
            id="Rectangle_6625"
            data-name="Rectangle 6625"
            width="18.836"
            height="3"
            transform="translate(2.628 14.303)"
            fill={color}
          />
          <rect
            id="Rectangle_6626"
            data-name="Rectangle 6626"
            width="3"
            height="15.104"
            transform="translate(10.546 15.092)"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

export default ChangeTemplateIcon;
